import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { card } from '../CSS/card'
import { font } from '../CSS/font'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import CardActionArea from '@material-ui/core/CardActionArea'
import {Line} from 'react-chartjs-2';

import moment from 'moment'


const styles = {...font,...card}
console.log(styles)

// card template

// need to pass in :
//            header : card title text, string,
//            subheader : card subtitle text, string,
//            content : card content, react component
//            contentText : card content, string
class CustomizedLineChart extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
        }
    }

    componentWillUpdate(prevProps) {
        if (this.state.data !== prevProps.data) {
            this.setState( {
                data: this.props.data,
            } )
        }
    }


    render() {
        let { classes } = this.props
        let tableRowIndex = 0
        // have to use switch because classes.XXX is a styling variable which can not be treated as value of a JSON file

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                datalabels: {
                    display: false
                }
            },
            elements: {
                line: {
                    tension: 0
                },
                point:{
                    radius:0,
                    hitRadius:5,
                    hoverRadius:5
                }
            },
            scales: {
                xAxes: [{
                    gridLines: {
                        color: "rgba(0, 0, 0, 0)",
                    }
                }],
                yAxes: [
                    {
                        gridLines: {
                            color: "rgba(0, 0, 0, 0)",
                        },
                        ticks: {
                            callback: function(label, index, labels) {
                                if(parseInt(label) >= 1000){
                                    return '$'+label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }else{
                                    return '$' + label;
                                }
                            }
                        },
                        scaleLabel: {
                            display: false,
                            labelString: 'Amount'
                        }
                    }
                ]
            },
            tooltips: {
                callbacks: {
                    label: function(tooltipItem, data) {
                        //console.log("1st chart data is "+data.datasets[0].data[tooltipItem.index])
                        var value = data.datasets[0].data[tooltipItem.index];
                        if(parseInt(value) >= 1000){
                            return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        } else {
                            return '$' + value;
                        }
                    }
                } // end callbacks:
            }, //end tooltips     
            title:{
                display:false,
                text: "Invoice Trending",
            },
            legend:{
                position:"bottom",
                display: false,
            }
        }



        return (
            <Line data={this.state.data} height={200} options={options}/>
        )
    }
}
export default withStyles(styles)(CustomizedLineChart);


// WEBPACK FOOTER //
// ./src/components/CSSComponent/lineChart.js